import React, { useState , useEffect } from "react";
import "./Home.css";
import {ToggleButtonGroup, ToggleButton} from "react-bootstrap";
import Slider from "../components/slider/slider";
import Footer from "../components/footer/footer";
import Header from "../components/Navbar";

import Pbottom from "../myimgs/Group53.png";
import layer1 from "../myimgs/Layer_1.png";
import layer2 from "../myimgs/Layer_2.png";
import myhome from "../myimgs/home1.png";
import bank from "../myimgs/bank.png";
import prime from "../myimgs/prime.png";
import sell from "../myimgs/sell.png";
import arowr from "../myimgs/Vector.png";


import b1 from "../myimgs/Twoffers_banner/1.jpg";
import b2 from "../myimgs/Twoffers_banner/2.jpg";
import b3 from "../myimgs/Twoffers_banner/3.jpg";
import b4 from "../myimgs/Twoffers_banner/4.jpg";



import Mobile1 from "../myimgs/Mobile (1).png"
import { Link } from "react-router-dom";

const Home = () => {
  const [mode, setMode] = useState("buy");
  const [propertyType, setPropertyType] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const images = [b1,b2,b3,b4]; // add as many as you like
  const [currentImage, setCurrentImage] = useState(0);
  const [loaded, setLoaded] = useState(false);

 useEffect(() => {
    let loadedCount = 0;
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) setLoaded(true);
      };
    });
  }, [images]);

  //Change background every 5s
  useEffect(() => {
    if (!loaded) return;
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [loaded, images.length]);

  return (
    <>
      <Header />
      {/* Hero Section */}
     <section className="hero-section scrolleffect">
  {/* Background image layers */}
  {images.map((img, index) => (
    <div
      key={index}
      className={`bg-slide ${index === currentImage ? "active" : ""}`}
      style={{ backgroundImage: `url(${img})` }}
    ></div>
  ))}

  {/* Permanent shadow overlay (always visible) */}
  <div className="bg-overlay"></div>
        {/* Overlay */}
        <div className="overlay">
          <div className="container text-white hero-content">
            <div className="row">
              {/* Left side content */}
              <div className="col-md-9 homseccol1">
                {/* Buy / Sell Toggle */}
                <ToggleButtonGroup
                  type="radio"
                  name="options"
                  value={mode}
                  onChange={(val) => setMode(val)}
                  className="mb-4"
                >
                  <ToggleButton
                    id="tbg-radio-1"
                    value="buy"
                    variant="light"
                    className="px-4 fw-bold"
                  >
                    Buy
                  </ToggleButton>
                  <ToggleButton
                    id="tbg-radio-2"
                    value="sell"
                    variant="light"
                    className="px-4 fw-bold"
                  >
                    Sell
                  </ToggleButton>
                </ToggleButtonGroup>

                {/* Small text */}
                <p className="subtitle">
                  {mode === "buy" ? (
                    <>Buy Anytime 24/7, 365 Days</>
                  ) : (
                    <>Sell Anytime  24/7, 365 Days</>
                  )}
                </p>

                <div className="pimg mb-4">
                  <img src={Pbottom} alt="" />
                </div>

                {/* Heading */}
                <h1 className="fw-bold display-5 hmergn">
                  {mode === "buy" ? (
                    <>
                      With 24/7 Canada-wide listings, you can browse, submit offers, and close deals anytime because opportunity never sleeps.
                    </>
                  ) : (
                    <>
                     Stay visible and ready. List your property and receive offers anytime because buyers don’t wait, and neither should you.
                    </>
                  )}
                </h1>

                {/* Button */}
                {mode === "buy" ? (
                  <Link to="/buyer">
                    <button className="arowr">
                      Explore All Properties <img src={arowr} alt="" />
                    </button>
                  </Link>
                ) : (
                  <Link to="/profile">
                    <button className="arowr">
                      List Your Property <img src={arowr} alt="" />
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Second Section */}
      <section className="w-full bg-gray-50 py-16">
        <div className="container homesecndsecn">
          <div className="row">
            <div className="col-md-6 d-flex homesecndcol gap-3 align-items-center">
              <img src={layer1} alt="" />
              <div className="lines"></div>
              <div className="para">
                <h3>Buy Property with Confidence</h3>
                <p>
                  Explore verified listings, get expert advice, and find the{" "}
                  <br></br>
                  perfect property that fits your lifestyle and budget.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex homesecndcol gap-3 align-items-center">
              <img src={layer2} alt="" />
              <div className="lines"></div>
              <div className="para">
                <h3>Ready to Sell Your Property</h3>
                <p>
                  Get the best value for your property with expert support,
                  verified buyers,and a smooth selling process from start to
                  finish.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Slider />
      <section className="w-full bg-gray-50 py-16">
        <div className="container weltrudis">
          <div className="row">
            <div className="col-md-12">
              <h2 className="fw-bold">Why Twoffers?</h2>
              {/* <h6>Your Trusted Real Estate Auction Partner</h6> */}
              <p className="pt-2">
                We simplify the property journey for everyone buyers, sellers,
                and investors. Browse verified listings, place real offers, and
                connect directly all on one transparent platform.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-gray-50 py-16">
        <div className="container lkiourls">
          <div className="row lineul">
            <div className="col-md-4">
              <ul>
                <h2>FOR BUYERS</h2>
                <li>
                 Offer on multiple properties at the same time with ease.
                </li>
                <li>
                 Need help? We’ll connect you to a local professional.
                </li>
                <li>
                 Our in-house team is also ready to assist you.
                </li>
                <li>Find your ideal property with expert or self-guided support.</li>
              </ul>
            </div>
            <div className="col-md-4 mile">
                <img src={Mobile1} alt="" />
            </div>
            <div className="col-md-4 mil2">
              <ul>
                <h2>FOR SELLERS</h2>
                <li>Promote your property through your professional realtor on our platform.</li>
                <li>
                 No agent? We’ll help you find one in your area.
                </li>
                <li>
                 Prefer doing it yourself? List directly and get multiple offers.
                </li>
                <li>Reach more buyers with flexible listing options.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="w-full bg-gray-50 py-16">
        <div className="container weltrudis">
          <div className="row">
            <div className="col-md-12">
              <h2 className="fw-bold">Experience the Twoffers Edge</h2>
              <h6>
                Where innovation meets real estate to deliver unmatched value.
              </h6>
            </div>
          </div>
          <div className="row yermili">
            <div className="col-md-3">
              <img src={Year} alt="" />
              <h2>15+</h2>
              <p>Years in Business</p>
            </div>
            <div className="col-md-3">
              <img src={milion} alt="" />
              <h2>2.5</h2>
              <p>Million Registered Users</p>
            </div>
            <div className="col-md-3">
              <img src={milion2} alt="" />
              <h2>250k+</h2>
              <p>Properties Sold</p>
            </div>
            <div className="col-md-3">
              <img src={milion3} alt="" />
              <h2>$25+</h2>
              <p>Billion in Real State Transactions</p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="w-full bg-gray-50 py-16">
        <div className="container-fluid"></div>
      </section>

      {/* Property Explore Section */}
      <section className="w-full bg-white py-16 bgground">
        <div className="container text-center">
          {/* Heading */}
          <h2 className="fw-bold mb-5">
            Explore listings, compare your options, and make offers in just a
            few clicks.
          </h2>
          {/* Property Cards */}
          <div className="row g-4 worowx">
            <div className="col-md-3">
              <div className="card h-100 shadow-sm border-0 text-center p-4">
                <div className="icon mb-3 homess">
                  <img src={myhome} alt="" />
                </div>
                <h5 className="fw-bold">
                  Fresh <br></br> Listings
                </h5>
                <p className="text-muted small">
                  Newly added properties, updated daily.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card h-100 shadow-sm border-0 text-center p-4">
                <div className="icon mb-3 bankafter">
                  <img src={bank} alt="" />
                </div>
                <h5 className="fw-bold">
                  Verified <br></br> Properties
                </h5>
                <p className="text-muted small">
                  All listings checked and quality assured.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card h-100 shadow-sm border-0 text-center p-4">
                <div className="icon mb-3 Primeafter">
                  <img src={prime} alt="" />
                </div>
                <h5 className="fw-bold">
                  Investment <br></br> Opportunities
                </h5>
                <p className="text-muted small">
                  Properties with potential, ready for your next move.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card h-100 shadow-sm border-0 text-center p-4">
                <div className="icon mb-3 sellafter">
                  <img src={sell} alt="" />
                </div>
                <h5 className="fw-bold">
                  Commercial & <br></br> Land
                </h5>
                <p className="text-muted small">
                  Offices, plots, retail spaces, and more.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
